
let visibility = (function() {

    var hidden, visibilityChange;

    if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }

    return {
        state: function() {
            return hidden ? document[hidden] : false
        },
        change: function(callback) {
            if (visibilityChange && typeof callback === 'function') {
                document.addEventListener(visibilityChange, function(e) {
                    callback(document[hidden])
                })
            }
        }
    }
})();

export default visibility;



// WEBPACK FOOTER //
// ./src/utils/visibility.js